export let SET_AVAILABLE_TIMES = "SET_AVAILABLE_TIMES";
